// @flow
import React, { useContext } from 'react';

import { t } from 'Src/i18n';
import * as pleUtils from 'Utils/ple-utils';
import { convertLocationToURI } from 'Utils/uri/uriUtils';
import ReactAppContext from 'Context/ReactAppContext';
import { useRouter } from 'Client/router/useRouter';
import { ICONS } from 'Components/utils/icon/icons';
import { Button } from 'Components/frameworks/button/Button';

type PrebookingFormLoginProps = {
  hasLoginButton: boolean,
  hasSeller: boolean,
  hasUser: boolean,
};

export const PrebookingFormLogin = (props: PrebookingFormLoginProps) => {
  const { locale } = useContext(ReactAppContext);
  const { location } = useRouter<{}, {}>();

  if (!props.hasLoginButton || props.hasSeller || props.hasUser) {
    return null;
  }

  return (
    <div className="flex flex-wrap lg:w-4/5 lg:mx-auto">
      <div className="my-3 px-3 w-full md:w-2/3">
        <p className="w-full my-0 text-base">{t('prebookingForm.login.memberSpace')}</p>
      </div>
      <div className="flex items-center justify-center my-3 px-3 w-full md:w-1/3">
        <Button
          dataTestId="prebooking-form-login"
          iconLeft={{ name: ICONS.USER }}
          trackingData={{
            categoryGA: 'preBookingForm',
            actionGA: 'logIn',
            labelGA: 'logIn',
          }}
          url={pleUtils.buildSigninUrl({
            locale,
            redirectUri: convertLocationToURI(location).toString(),
          })}
          isExternalLink
        >
          {t('prebookingForm.login.labelCTA')}
        </Button>
      </div>
      <hr className="block border-0 border-solid border-gray-light border-t-1 h-px my-4 mx-0 p-0" />
    </div>
  );
};
